import './tabs.scss';

interface IOption<T> {
  value: T;
  label: string;
}

interface IProps<T> {
  value: T;
  options: IOption<T>[];
  onChange: (value: T, option: IOption<T>) => void;
}

function Tabs<T>({ value, options, onChange }: IProps<T>) {
  return (
    <div className="tabs">
      {options.map((option) => (
        <button
          key={option.value as string}
          type="button"
          className={`tabs__option ${value === option.value ? 'tabs__option--active' : ''}`}
          onClick={() => onChange(option.value, option)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
